import { useSignNamesLazyQuery } from '@kinetic-ui/data-layer';
import { DataSource, FormOption } from '@qfa/forms';
import { getNodes } from 'kineticUtils';
import { useCallback } from 'react';

export const useSignNamesDataSource = (): DataSource<FormOption[]> => {
  const [getSignNames] = useSignNamesLazyQuery();

  const load = useCallback(async () => {
    const { data } = await getSignNames();
    const signOptions = getNodes(data?.signs).map((sign) => ({
      label: sign.name,
      value: sign.id,
    }));

    return signOptions as FormOption[];
  }, [getSignNames]);

  return { load };
};
